import React from 'react';
import { Carousel } from '../../../../../components/Carousel';
import styles from './PlusProductSummary.module.scss';
import { Image as FiImage } from '../../../../../components/Image';
import { showNanoVariant } from '../../../../../components/NanoBanner/NanoBanner';

export const PhoneProductCarousel = () => {
  // The Mini and Ultra PDPs render their app-screenshot carousels
  // unconditionally; the Series 3+ carousel used to sit behind the
  // `ecom-phone-product-carousel` flag, which left it absent in any
  // non-prod (preview/dev) GrowthBook environment. Drop the gate so it
  // renders consistently across all three PDPs. The nano-variant flow still
  // hides the whole app section, matching the microchip experience.
  const hideMobileAppSection = showNanoVariant();

  if (hideMobileAppSection) {
    return null;
  }

  return (
    <>
      <Carousel className={styles.mobileAppCarousel} wrapAround={true} prevNextButtons={true}>
        <div className={styles.mobileAppImage}>
          <FiImage
            image={{
              type: 'image',
              url: '/product_images/smart-collar-v3b/app-ui-homescreen-1.png',
              descriptors: ['1000w'],
            }}
            loading="eager"
          />
        </div>
        <div className={styles.mobileAppImage}>
          <FiImage
            image={{
              type: 'image',
              url: '/product_images/smart-collar-v3b/app-ui-homescreen-2.png',
              descriptors: ['1000w'],
            }}
            loading="eager"
          />
        </div>
        <div className={styles.mobileAppImage}>
          <FiImage
            image={{
              type: 'image',
              url: '/product_images/smart-collar-v3b/app-ui-homescreen-3.png',
              descriptors: ['1000w'],
            }}
            loading="eager"
          />
        </div>
      </Carousel>
    </>
  );
};
